export default __webpack_public_path__ + "static/media/Kanipakam-slider-02@2x.2fbff57e.png";